import { describirCambios } from "./registrarAccion";

const ETIQUETAS_CLIENTE = {
  sisven_id: "Sisven ID",
  razon_social: "Razón social",
  direccion_fiscal: "Dirección fiscal",
  telefono_1: "Teléfono 1",
  telefono_2: "Teléfono 2",
  telefono_3: "Teléfono 3",
  mails: "Mails",
  tipo_doc_afip: "Tipo doc.",
  cuit: "CUIT/DNI",
  id_sucursal: "Sucursal",
  id_localidad: "Localidad",
  id_comercial: "Comercial",
  situacion_iva: "Situación IVA",
  id_condicionpago: "Condición de pago",
  id_tipocliente: "Tipo de cliente",
  uso: "Uso",
  observaciones: "Observaciones",
  observaciones_cuenta_corriente: "Observaciones cta. cte.",
  factura_consfinal: "Factura a cons. final",
  porc_perc_iva: "% percepción IVA",
  porc_exc_perc_iva: "% exención percepción IVA",
  vto_exc_perc_iva: "Vto. exención",
  precio_especial: "Precio especial",
  entrega_con_remito: "Entrega con remito",
  facturar_a: "Facturar a (ID cliente)",
  id_convenio: "Convenio IIBB",
  iibb_nro_inscripcion: "Nro. inscripción IIBB",
};

const nombreEn = (lista, id, campo, key = "id") =>
  lista?.find((x) => String(x[key]) === String(id))?.[campo] ?? id;
const siNo = (v) => (Number(v) === 1 ? "Sí" : "No");
const num = (v) => (v === null || v === undefined || v === "" ? null : Number(v));

// Arma el texto de cambios de una edición de cliente envasado, con valores legibles
// (nombres en vez de IDs, Sí/No en vez de 0/1).
// orig: cliente antes de editar (teléfonos sin +549)
// datosGuardar: payload del PUT
// listas: { sucursales, localidades, comerciales, sitIva, condiciones, tipoCliente, usos, convenios }
// sel: { sucursal, localidad, comercial, sitIva, condPago, tipoCliente, uso, convenio } (objetos seleccionados)
export const describirCambiosCliente = (orig, datosGuardar, listas, sel) => {
  const antes = {
    ...orig,
    id_sucursal: nombreEn(listas.sucursales, orig.id_sucursal, "nombre"),
    id_localidad: nombreEn(listas.localidades, orig.id_localidad, "localidad"),
    id_comercial: nombreEn(listas.comerciales, orig.id_comercial, "nombre_apellido"),
    situacion_iva: nombreEn(listas.sitIva, orig.situacion_iva, "descripcion"),
    id_condicionpago: nombreEn(listas.condiciones, orig.id_condicionpago, "condicion"),
    id_tipocliente: nombreEn(listas.tipoCliente, orig.id_tipocliente, "descripcion"),
    uso: nombreEn(listas.usos, orig.uso, "uso"),
    id_convenio: nombreEn(listas.convenios, orig.id_convenio, "convenio", "id_convenio"),
    factura_consfinal: siNo(orig.factura_consfinal),
    precio_especial: siNo(orig.precio_especial),
    entrega_con_remito: siNo(orig.entrega_con_remito),
    porc_perc_iva: num(orig.porc_perc_iva),
    porc_exc_perc_iva: num(orig.porc_exc_perc_iva),
  };
  const despues = {
    ...datosGuardar,
    id_sucursal: sel.sucursal?.nombre ?? datosGuardar.id_sucursal,
    id_localidad: sel.localidad?.localidad ?? datosGuardar.id_localidad,
    id_comercial: sel.comercial?.nombre_apellido ?? datosGuardar.id_comercial,
    situacion_iva: sel.sitIva?.descripcion ?? datosGuardar.situacion_iva,
    id_condicionpago: sel.condPago?.condicion ?? datosGuardar.id_condicionpago,
    id_tipocliente: sel.tipoCliente?.descripcion ?? datosGuardar.id_tipocliente,
    uso: sel.uso?.uso ?? datosGuardar.uso,
    id_convenio: sel.convenio?.convenio ?? datosGuardar.id_convenio,
    factura_consfinal: siNo(datosGuardar.factura_consfinal),
    precio_especial: siNo(datosGuardar.precio_especial),
    entrega_con_remito: siNo(datosGuardar.entrega_con_remito),
    porc_perc_iva: num(datosGuardar.porc_perc_iva),
    porc_exc_perc_iva: num(datosGuardar.porc_exc_perc_iva),
  };

  return describirCambios(antes, despues, ETIQUETAS_CLIENTE);
};
